import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  useColorModeValue,
  SimpleGrid,
  Input,
  Image,
} from "@chakra-ui/react";
import axios from "axios";
import qs from "qs";

// Custom components
import Banner from "views/admin/profile/components/Banner";

// Assets
import tableDataTopCreators from "views/admin/marketplace/variables/tableDataTopCreators.json";
import { tableColumnsTopCreators } from "views/admin/marketplace/variables/tableColumnsTopCreators";
import TableFriends from "./components/TableFriends";
import {
  columnsDataFriendList,
  columnsDataFriends,
  columnsDataFriendsRequest,
} from "./variables/columnsData";
import { Divider } from "@mui/material";
import Global from "../../../assets/img/global.png";
import Add from "../../../assets/img/add.png";

export default function FriendList() {
  const [user, setUser] = useState();
  const [friends, setFriends] = useState([]);
  const [colleague, setColleague] = useState([]);
  // const [friendRequest, setFriendRequest] = useState([]);
  const [refetch, setRefetch] = useState(0);
  // const navigate = useNavigate()
  // const styles = useStyles();

  const [paginationFriend, setPaginationFriend] = useState({
    limit: 5,
    page: 1,
    max: 1,
    total: 1,
  });
  const [paginationFriendRequest, setPaginationFriendRequest] = useState({
    limit: 5,
    page: 1,
    max: 1,
    total: 1,
  });
  const [paginationColleague, setPaginationColleague] = useState({
    limit: 5,
    page: 1,
    max: 1,
    total: 1,
  });
  const [searchColleague, setSearchColleague] = useState([]);
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    let localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
    } else {
      // navigate('/')
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(
        `https://api.personatalenta.id/user/friendship/?limit=${paginationFriend.limit}&page=${paginationFriend.page}`,
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        }
      )
      .then((res) => {
        setFriends(res.data?.friendship);
        setPaginationFriend({
          ...paginationFriend,
          max: res.data.totalPages,
          total: res.data.totalCount,
        });
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  }, [paginationFriend.page, paginationFriend.limit, refetch]);

  console.log(refetch);

  // useEffect(() => {
  //   const token = localStorage.getItem('token');
  //   axios.get(`https://api.personatalenta.id/user/friendship/request?limit=${paginationFriendRequest.limit}&page=${paginationFriendRequest.page}`, { headers: { Authorization: `Bearer ${token ? token : ''}`, "Content-Type": "x-www-from-urlencode" } })
  //     .then(res => {
  //       setFriendRequest(res.data?.friendship)
  //       setPaginationFriendRequest({ ...paginationFriendRequest, max: res.data.totalPages, total: res.data.totalCount })
  //     }).catch(err => {
  //       if (err.response?.data?.message === "Unauthorized" || err.response?.data === "Unauthorized") {
  //         // navigate('/');
  //       }
  //     })
  // }, [paginationFriendRequest.page, paginationFriendRequest.limit]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(
        `https://api.personatalenta.id/user/colleague?limit=${paginationColleague.limit}&page=${paginationColleague.page}`,
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        }
      )
      .then((res) => {
        setColleague(res?.data?.colleagues);
        setPaginationColleague({
          ...paginationColleague,
          max: res.data.totalPages,
          total: res.data.totalCount,
        });
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err?.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  }, [paginationColleague.page, paginationColleague.limit, refetch]);

  useEffect(() => {
    let localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
      // console.log(user)
    } else {
      window.location.assign("/home");
    }
  }, []);

  const onChangeSearch = (text) => {
    setSearchColleague(text.target.value);

    const token = localStorage.getItem("token");

    if (token) {
      if (text.target.value.length > 2) {
        axios
          .get(
            `https://api.personatalenta.id/user/colleague?search=${text.target.value}`,
            {
              headers: {
                Authorization: `Bearer ${token ? token : ""}`,
                "Content-Type": "x-www-from-urlencode",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": "true",
                "Access-Control-Allow-Headers":
                  "Origin, X-Requested-With, Content-Type, Accept",
              },
            }
          )
          .then((res) => {
            setSearchData(res?.data?.colleagues);
            // setCards(res?.data?.cards)
          })
          .catch((err) => {
            if (
              err.response?.data?.message === "Unauthorized" ||
              err.response?.data === "Unauthorized"
            ) {
              // navigate('/');
            }
          });
      } else {
        setSearchData([]);
      }
    }
  };

  const nextPage = (type) => {
    if (type === "friend") {
      if (paginationFriend.page < paginationFriend.max) {
        setPaginationFriend({
          ...paginationFriend,
          page: paginationFriend.page + 1,
        });
      }
    } else if (type === "request") {
      if (paginationFriendRequest.page < paginationFriendRequest.max) {
        setPaginationFriendRequest({
          ...paginationFriendRequest,
          page: paginationFriendRequest.page + 1,
        });
      }
    } else if (type === "colleague") {
      if (paginationColleague.page < paginationColleague.max) {
        setPaginationColleague({
          ...paginationColleague,
          page: paginationColleague.page + 1,
        });
      }
    }
  };

  const prevPage = (type) => {
    if (type === "friend") {
      if (paginationFriend.page > 1) {
        setPaginationFriend({
          ...paginationFriend,
          page: paginationFriend.page - 1,
        });
      }
    } else if (type === "request") {
      if (paginationFriendRequest.page > 1) {
        setPaginationFriendRequest({
          ...paginationFriendRequest,
          page: paginationFriendRequest.page - 1,
        });
      }
    } else if (type === "colleague") {
      if (paginationColleague.page > 1) {
        setPaginationColleague({
          ...paginationColleague,
          page: paginationColleague.page - 1,
        });
      }
    }
  };

  const firstPage = (type) => {
    if (type === "friend") {
      setPaginationFriend({ ...paginationFriend, page: 1 });
    } else if (type === "request") {
      setPaginationFriendRequest({ ...paginationFriendRequest, page: 1 });
    } else if (type === "colleague") {
      setPaginationColleague({ ...paginationColleague, page: 1 });
    }
  };

  const lastPage = (type) => {
    if (type === "friend") {
      setPaginationFriend({ ...paginationFriend, page: paginationFriend.max });
    } else if (type === "request") {
      setPaginationFriendRequest({
        ...paginationFriendRequest,
        page: paginationFriendRequest.max,
      });
    } else if (type === "colleague") {
      setPaginationColleague({
        ...paginationColleague,
        page: paginationColleague.max,
      });
    }
  };

  const goToPage = (type, page) => {
    if (type === "friend") {
      setPaginationFriend({ ...paginationFriend, page: page });
    } else if (type === "request") {
      setPaginationFriendRequest({ ...paginationFriendRequest, page: page });
    } else if (type === "colleague") {
      setPaginationColleague({ ...paginationColleague, page: page });
    }
  };

  const limitPage = (type, limit) => {
    if (type === "friend") {
      setPaginationFriend({ ...paginationFriend, limit: limit });
    } else if (type === "request") {
      setPaginationFriendRequest({ ...paginationFriendRequest, limit: limit });
    } else if (type === "colleague") {
      setPaginationColleague({ ...paginationColleague, limit: limit });
    }
  };

  const onClickAction = (props) => {
    const token = localStorage.getItem("token");
    axios
      .post(
        `https://api.personatalenta.id/user/friendship/respond-request/${props.id}`,
        qs.stringify({ status: props.value }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        console.log("err: ", err);
        // setError(err.response.data.message || err.response.data)
      });
  };

  // const onChangeMenu = menu => {
  //   if (menu === 0) {
  //     setActiveMenu(0);
  //   } else if (menu === 1) {
  //     setActiveMenu(1);
  //   } else if (menu === 2) {
  //     setActiveMenu(2);
  //   }
  // }

  const onDeleteFriend = (id) => {
    const token = localStorage.getItem("token");
    axios
      .delete(
        `https://api.personatalenta.id/user/friendship/delete-friend/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        }
      )
      .then((res) => {
        setRefetch(refetch + 1);
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err?.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  };

  const onDeleteFriendColleague = (id) => {
    const token = localStorage.getItem("token");
    axios
      .put(
        `https://api.personatalenta.id/user/colleague/hide/hide/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        }
      )
      .then((res) => {
        setRefetch(refetch + 1);
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err?.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  };

  const onClickColleague = (id) => {
    const token = localStorage.getItem("token");
    axios
      .put(
        `https://api.personatalenta.id/user/colleague/hide/unhide/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        window.location.assign(`/dashboard/friend-list/colleague/${id}`);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  return (
    <Box
      id="friend"
      pt={{ sm: 10, base: "130px", md: "80px", xl: "80px" }}
      mt={{ sm: 15, md: 5 }}
    >
      <Grid gap={{ base: "10px", xl: "20px" }}>
        <Flex gap={{ sm: 1, md: 1 }} flex={1} flexDirection="column">
          <Flex gap={5} width={{ sm: "100%", md: "50%" }} direction="row">
            <Flex
              borderColor="#68349A"
              borderWidth={1}
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#68349A"}
            >
              <Text
                fontSize={{ sm: "xs", md: "sm" }}
                color={"#FFF"}
                fontWeight={"bold"}
              >
                Colleague
              </Text>
            </Flex>
            <Button
              borderWidth={1}
              bgColor="purple"
              borderColor="#68349A"
              color="#fff"
              fontSize="sm"
              fontWeight="bold"
              borderRadius="5px"
              px="10px"
              py="5px"
              gap={2}
              onClick={() =>
                window.location.assign("/dashboard/friend-list/add-colleague")
              }
            >
              <Flex borderWidth={2} borderColor="white" borderRadius={100}>
                <Image
                  src={Add}
                  w={{ base: "25px", "3xl": "25px" }}
                  h={{ base: "25px", "3xl": "25px" }}
                  borderRadius="20px"
                  borderColor="white"
                  borderWidth={2}
                />
              </Flex>
              <Text color={"#fff"}>Tambah Colleague</Text>
            </Button>
            <Flex flexDirection="column" width="30%">
              <Input
                value={searchColleague}
                border="1px solid #68349A"
                px={3}
                py={2}
                borderRadius={5}
                width="100%"
                fontSize={{ sm: "xs", md: "sm" }}
                placeholder="Cari colleague (min 3 huruf)"
                onChange={onChangeSearch}
              />
              {searchData.length > 0 && (
                <Flex
                  flexDirection="column"
                  flex={1}
                  gap={2}
                  position="relative"
                >
                  <Flex
                    flexDirection="column"
                    width="100%"
                    flex={1}
                    gap={2}
                    position="absolute"
                    backgroundColor="#fff"
                    borderWidth={1}
                    px={5}
                    py={2}
                    zIndex={1}
                  >
                    {searchData.map((data, index) => (
                      <Button
                        key={index}
                        justifyContent="start"
                        color={"black"}
                        fontSize={{ sm: "xs", md: "sm" }}
                        onClick={() => onClickColleague(data.id)}
                        py="5px"
                      >
                        <Text isTruncated maxWidth="200px">
                          {data.name}
                        </Text>
                      </Button>
                    ))}
                  </Flex>
                </Flex>
              )}
            </Flex>
          </Flex>
          <Text fontStyle="italic" fontSize="xs">
            Colleague adalah teman yang anda masukkan secara manual: nama,
            tahun, tanggal dan jam lahir
          </Text>
        </Flex>
        <Grid mb={20}>
          <TableFriends
            columnsData={columnsDataFriendList}
            tableData={colleague}
            // title="Friends Colleague"
            type="colleague"
            pagination={paginationColleague}
            nextPage={nextPage}
            prevPage={prevPage}
            firstPage={firstPage}
            lastPage={lastPage}
            limitPage={limitPage}
            goToPage={goToPage}
            onDeleteFriend={onDeleteFriendColleague}
          />
        </Grid>
      </Grid>
      <Grid gap={{ base: "20px", xl: "20px" }}>
        <Flex gap={{ sm: 1, md: 30 }} flex={1}>
          <Flex gap={5} width={{ sm: "100%", md: "100%" }} direction="row">
            <Flex
              borderColor="#68349A"
              borderWidth={1}
              borderTopRadius={8}
              padding="5px 10px"
              backgroundColor={"#68349A"}
            >
              <Text
                fontSize={{ sm: "xs", md: "sm" }}
                color={"#FFF"}
                fontWeight={"bold"}
              >
                Friends on Apps
              </Text>
            </Flex>
            <Button
              borderWidth={1}
              borderColor="#1877f2"
              bgColor="transparent"
              color="#fff"
              fontSize="sm"
              fontWeight="bold"
              borderRadius="5px"
              px="10px"
              py="5px"
              onClick={() =>
                window.location.assign("/dashboard/friend-list/add-friend")
              }
            >
              <Text color={"#000"}>Cari teman di aplikasi</Text>
              {/* <Image
                src={Global}
                w={{ base: "25px", "3xl": "25px" }}
                h={{ base: "25px", "3xl": "25px" }}
                borderRadius='20px'
              /> */}
            </Button>
          </Flex>
        </Flex>
        <Grid mb={20}>
          <TableFriends
            columnsData={columnsDataFriends}
            tableData={friends}
            // title="Friends Apps"
            type="friend"
            pagination={paginationFriend}
            nextPage={nextPage}
            prevPage={prevPage}
            firstPage={firstPage}
            lastPage={lastPage}
            limitPage={limitPage}
            goToPage={goToPage}
            onDeleteFriend={onDeleteFriend}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
